<template>
  <div
    ref="convstooltip"
    class="con-vs-tooltip"
    @mouseout="mouseoutx"
    @mouseover="mouseoverx"
  >
    <transition name="tooltip-fade">
      <div
        v-if="active"
        ref="vstooltip"
        :class="[
          `vs-tooltip-${positionx || position}`,
          { 'after-none': noneAfter },
        ]"
        :style="style"
        class="vs-tooltip text-base"
      >
        <h4 :style="headerStyle" v-if="title">{{ title }}</h4>
        <div class="tooltip-content">
          <slot name="content"></slot>
        </div>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
import utils from "@/assets/utils";
import _color from "@/assets/utils/color.js";
export default {
  name: "vx-tooltip",
  props: {
    title: {
      default: null,
      type: [String, Number],
    },
    text: {
      default: null,
      type: [String, Number],
    },
    color: {
      default: null,
      type: String,
    },
    position: {
      default: "top",
      type: String,
    },
    delay: {
      default: "0s",
      type: [Number, String],
    },
  },
  data: () => ({
    cords: {},
    active: false,
    widthx: "auto",
    positionx: null,
    noneAfter: false,
  }),
  computed: {
    headerStyle() {
      return {
        color: this.getGrayscaleTextColor(this.color),
      };
    },
    style() {
      return {
        left: this.cords.left,
        top: this.cords.top,
        transitionDelay: this.active ? this.delay : "0s",
        background: _color.getColor(this.color, 1),
        width: this.widthx,
        color: this.getGrayscaleTextColor(this.color),
      };
    },
  },
  methods: {
    mouseoverx() {
      this.active = true;
      this.$nextTick(() => {
        utils.insertBody(this.$refs.vstooltip);
        this.changePosition(this.$refs.convstooltip, this.$refs.vstooltip);
      });
    },
    mouseoutx() {
      this.active = false;
    },
    getGrayscaleTextColor(hexcolor) {
      hexcolor = hexcolor.replace("#", "");
      const r = parseInt(hexcolor.substr(0, 2), 16);
      const g = parseInt(hexcolor.substr(2, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // If luminance is high (light background), return black; if low (dark background), return white
      return luminance > 0.5 ? "black" : "white";
    },
    changePosition(elxEvent, tooltip) {
      this.noneAfter = false;
      this.positionx = null;
      let elx = elxEvent.closest(".con-vs-tooltip");
      let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
      let topx =
        elx.getBoundingClientRect().top + scrollTopx - tooltip.clientHeight - 4;
      let leftx =
        elx.getBoundingClientRect().left -
        tooltip.clientWidth / 2 +
        elx.clientWidth / 2;
      let widthx = elx.clientWidth;

      if (this.position == "bottom") {
        topx =
          elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
      } else if (this.position == "left") {
        leftx = elx.getBoundingClientRect().left - tooltip.clientWidth - 4;
        topx =
          elx.getBoundingClientRect().top +
          scrollTopx +
          elx.clientHeight / 2 -
          tooltip.clientHeight / 2;
        if (Math.sign(leftx) == -1) {
          leftx = elx.getBoundingClientRect().left;
          topx =
            elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
          this.positionx = "bottom";
          this.noneAfter = true;
        }
      } else if (this.position == "right") {
        leftx = elx.getBoundingClientRect().left + elx.clientWidth + 4;
        topx =
          elx.getBoundingClientRect().top +
          scrollTopx +
          elx.clientHeight / 2 -
          tooltip.clientHeight / 2;
        if (window.innerWidth - (leftx + tooltip.clientWidth) <= 20) {
          leftx =
            elx.getBoundingClientRect().left - tooltip.clientWidth / 2 - 10;
          topx =
            elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
          this.positionx = "bottom";
          this.noneAfter = true;
        }
      }
      this.cords = {
        left: `${leftx}px`,
        top: `${topx}px`,
        width: `${widthx}px`,
      };
    },
  },
  beforeDestroy() {
    this.active = false;
  },
};
</script>

<style scoped>
.vs-tooltip h4 {
  font-size: 1rem;
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: 400;
}

.vs-tooltip {
  z-index: 10000000 !important;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
}

/* .tooltip-content {
  background: inherit;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  filter: invert(1) grayscale(1);
  -webkit-filter: invert(1) grayscale(1);
} */
</style>
